import { OnboardingSources } from "../components/signup/types";
import { COUNTRIES } from "../const/countries.const";
import FormAutoComplete from "../yoello-lib/modules/dynamicForms/FormComponents/FormAutoComplete";
import FormTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import { getIntegrationExtraInputs } from "./signup.form";

const HostsAbleToSelectCountryList = [OnboardingSources.partners,OnboardingSources.deliverect,OnboardingSources.ncr,OnboardingSources.oracle]
export function newVenueForm(onboardingSource: string, t: any, disableCountry?: boolean): IDynamicFormRow[] {
    
    function getCountries() {
        const countries = [...COUNTRIES];

        if (onboardingSource === OnboardingSources.zerobubble) {
            countries.push({ key: "malta", name: "Malta", code: "MT" })
        }

        if (onboardingSource === OnboardingSources.bna) {
            countries.push({ key: "canada", name: "Canada", code: "CA" })
        }

        return countries.map((country) => ({
            name: t(`countries.${country.key}`),
            value: country.code,
        }));
    }

    let newVenueFormRows:IDynamicFormRow[] = [
        {
            label: "forms.details.venueName",
            keyName: "venue_name",
            gridColumnOptions: { formCol: 12 },
            Component: FormTextBox,
            registerOptions: {
                required: true,
            },
        }, {
            label: "forms.details.venueCountry",
            keyName: "venue_location",
            formProps: {
                selectOptions: getCountries()
            },
            inputProperties: {
                required: true,
                helperText: ""
            },
            Component: FormAutoComplete,
            gridColumnOptions: { formCol: 12 },
            registerOptions: {
                required: true,
            },
            // @ts-ignore
            disabled: !HostsAbleToSelectCountryList.includes(onboardingSource) || disableCountry
        }
    ];
    if(onboardingSource.toUpperCase() !== "PARTNERS"){
        newVenueFormRows.push(...getIntegrationExtraInputs(onboardingSource.toUpperCase(), true))
    }
    
    return newVenueFormRows;
}